import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, filter, takeUntil } from 'rxjs/operators';

import { SearchPortfolio } from '../../shared/models/search-portfolio-model';

import { PortfolioService } from '../../shared/_services/portfolio.service';
import { OfficeService } from '../../shared/_services/office.service';
import { BranchService } from '../../shared/_services/branch.service';
import { Branch, Office } from '../../shared/models/missingdata.model';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {


  searchForm: FormGroup;
  searchPortfolio: SearchPortfolio;
  searchPortfolioList: SearchPortfolio[];
  offices: Office[];
  branches: Branch[];

  formatterOffice = (result: { officeName: number }) => result.officeName;
  formatterBranch = (result: { branchName: number }) => result.branchName;

  constructor(private formBuilder: FormBuilder,
    private portfolioService: PortfolioService,
    private officeService: OfficeService,
    private branchService: BranchService,
    private router: Router) {

    //// override the route reuse strategy
    //this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //  return false;
    //}

    //this.router.events.pipe(takeUntil(this.destroyed)).subscribe((evt) => {
    //  if (evt instanceof NavigationEnd) {
    //    // trick the Router into believing it's last link wasn't previously loaded
    //    this.router.navigated = false;
    //    console.log(evt);
    //  }
    //});
  }


  get f() { return this.searchForm.controls; }

  ngOnInit() {
    //this.router.events.pipe(
    //  filter((event: RouterEvent) => event instanceof NavigationEnd),
    //  takeUntil(this.destroyed)
    //).subscribe((data: any) => {
    //  if (data.urlAfterRedirects === "/search") {
    //    this.ngOnDestroy();
    //    this.ngOnInit();
    //  }
    //  console.log(data);
    //});

    // consulta de campos para autocompletar
    this.officeService.getOffices()
      .subscribe(offices => {
        this.offices = offices;
      });

    this.branchService.getBranches()
      .subscribe(branches => {
        this.branches = branches;
      });

    this.searchPortfolio = new SearchPortfolio();

    // inicialización de formulario de búsqueda
    this.searchForm = this.formBuilder.group({
      idOffice: ['',],
      idBranch: ['',],
      idPolicy: ['',],
      idAnnexed: ['',],
      debtorName: ['',],
      letterNumber: ['',],
      idDebtor: ['',],
      onlyActivePortfolio: ['',]

    });

    Observable.combineLatest(this.f.idOffice.valueChanges.startWith(null), this.f.idBranch.valueChanges.startWith(null), this.f.idAnnexed.valueChanges.startWith(null))
      .subscribe(([changeOffice, changeBranch, changeAnnexed]) => {

        // si existe un valor en cualquiera de los campos de la llave (excepto Póliza)
        // le agrega un validador requerido al campo "Póliza"
        if (changeOffice || changeBranch || changeAnnexed) {
          this.searchForm.controls['idPolicy'].setValidators([Validators.required]);
          this.searchForm.controls['idPolicy'].updateValueAndValidity();
        } else {
          this.searchForm.controls['idPolicy'].clearValidators();
          this.searchForm.controls['idPolicy'].updateValueAndValidity();

        }
      });
  }


  searchTermOffice = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : (this.offices.filter(v => v.officeName.indexOf(term.toUpperCase()) > -1 ||
          v.idOffice == +term))
      )
    )

  searchTermBranch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : (this.branches.filter(v => v.branchName.indexOf(term.toUpperCase()) > -1 ||
          v.idBranch == +term))
      )
    )

  selectedItem(item: any, element: any) {
    if (element.id === 'idOffice') {
      this.searchPortfolio.idOffice = item.item.idOffice;
    } else if (element.id === 'idBranch') {
      this.searchPortfolio.idBranch = item.item.idBranch;
    }
  }

  getDebtorPortfolio(idDebtor, idPolicy) {
    //this.router.navigate(['portfolio/detail/', { id: idDebtor, idPolicy: idPolicy }]);
    this.router.navigate(['portfolio/detail/', idDebtor, idPolicy]);
  }

  @ViewChild('checkbox') checkbox: ElementRef;

  search() {
    this.portfolioService.sendPortfolioSearch(this.searchPortfolio)
      .subscribe((res: SearchPortfolio[]) => {
        this.searchPortfolioList = res;
        console.log(res)
      }, err => console.log(err)
      );
    this.searchPortfolio = new SearchPortfolio();
    this.searchForm.reset();
    //document.getElementById('inlineRadio1').checked = true;
    this.checkbox.nativeElement.checked;
    this.searchForm.controls['onlyActivePortfolio'].setValue(false);
  }

  reloadPage() {
    //this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //  return false;
    //};
  }
}
